import React from 'react';
import Style from './SignInSeparator.module.scss';

const SignInSeparator = () => (
  <div className={Style.signInSeparatorContainer}>
    <div className={Style.signInSeparator}>
      <span className={Style.signInSeparatorLine} />
      <span className={Style.signInSeparatorText}>OR</span>
      <span className={Style.signInSeparatorLine} />
    </div>
  </div>
);

export default SignInSeparator;
